import React from 'react';
// Svgs
import logoOhif from './../../assets/svgs/ohif-logo.svg';
import logoVIDAA from './../../assets/svgs/vidaa-logo-cropped.svg';
import logoVIDAABlack from './../../assets/svgs/vidaa-logo-black.svg';
const SVGS = {
  'logo-ohif': logoOhif,
  'logo-vidaa': logoVIDAA,
  'logo-vidaa-black': logoVIDAABlack
};

/**
 * Return the matching SVG as a React Component.
 * Results in an inlined SVG Element. If there's no match,
 * return `null`
 */
export default function getSvg(key, props) {
  if (!key || !SVGS[key]) {
    return React.createElement('div', null, 'Missing SVG');
  }

  return React.createElement(SVGS[key], props);
}

export { SVGS };
